import { defenseData, calcResourceGatherTime, calcShipBuildTime } from '../../data';
import { timesResources } from '../../resources';
import { StateFastForward } from '../core';
import { makeTimelineEntry, makeInvalidEntry } from '../timelineEntries';
import { captureStateSnapshot } from '../snapshot';
import { waitWhile, drainShorterThan } from '../waits';

export const handleBuildDefense = (state, timeline, recorder, action, index) => {
  const { payload } = action;
  const { planetId, defense, count } = payload;

  const cost = timesResources(defenseData[defense].cost(), count);

  // Can't queue defense while the hangar itself is being upgraded (shares
  // the shipyard queue/build-time formula with ships).
  if (state.planets[planetId].buildAction !== undefined && state.planets[planetId].buildAction.payload.building === 'hangar') {
    state = waitWhile(state, timeline, recorder, planetId, (s) => s.planets[planetId].buildAction !== undefined);
  }

  let available = defenseData[defense].available(state, planetId);
  if (!available) {
    // Not available yet — maybe a research in progress will unlock it.
    state = waitWhile(state, timeline, recorder, planetId, (s) => s.researchAction !== undefined);
    available = defenseData[defense].available(state, planetId);
    if (!available) {
      timeline.push(makeInvalidEntry(state, planetId, index, `Start ${defenseData[defense].name} ${count}`));
      return state;
    }
  }

  let gatherTime = calcResourceGatherTime(state, planetId, { ...cost });
  if (gatherTime < 0) {
    timeline.push(makeInvalidEntry(state, planetId, index, `Start ${defenseData[defense].name} ${count}`));
    return state;
  }

  const drained = drainShorterThan(state, timeline, recorder, planetId, gatherTime, (s) =>
    calcResourceGatherTime(s, planetId, { ...cost })
  );
  state = drained.state;
  gatherTime = drained.threshold;

  if (gatherTime > 0) {
    const beforeGatherState = captureStateSnapshot(state, planetId);
    timeline.push(makeTimelineEntry('gather', state, { ...action, duration: gatherTime, index }, beforeGatherState));
    state = StateFastForward(state, planetId, gatherTime, recorder);
    timeline[timeline.length - 1].stateAfter = captureStateSnapshot(state, planetId);
  }

  // Batch semantics mirror buildShip.js: gather the full cost for `count`
  // units, pay it all at once, then build them one-by-one from the shared
  // shipyard queue (planet.shipActions), same queue ships use.
  const beforeDefenseState = captureStateSnapshot(state, planetId);
  const planet = state.planets[planetId];
  planet.resources.metal -= cost.metal;
  planet.resources.crystal -= cost.crystal;
  planet.resources.deuterium -= cost.deuterium;
  for (let i = 0; i < count; i++) {
    planet.shipActions.push({
      ...action,
      duration: calcShipBuildTime(state, planetId, defenseData[defense].cost(0)),
      index: index + 'S' + i,
    });
  }
  state.planets[planetId] = planet;

  recorder.record(state, planetId, `Started building ${count} ${defenseData[defense].name}`);

  timeline.push(
    makeTimelineEntry(
      'start',
      state,
      {
        ...action,
        duration: planet.shipActions.reduce((acc, x) => acc + x.duration, 0), // ready when all queued shipyard items (old + new) are done
        index,
      },
      beforeDefenseState,
      captureStateSnapshot(state, planetId)
    )
  );

  return state;
};
